const SortSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path
        d="M3.71429 11V4.75M3.71429 11L2 9.125M3.71429 11L5.42857 9.125M8.28571 1V7.25M8.28571 1L10 2.875M8.28571 1L6.57143 2.875"
        stroke="#333333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SortSvg;
